<template>
  <div>
    <md-dialog
      role="dialog"
      :aria-modal="confirmjustopen"
      id="sessionalreadyopen-dialog"
      :md-active="confirmjustopen"
      :no-close-on-esc="false"
      :md-click-outside-to-close="false"
      @keydown.esc="showDialog = false"
      @keydown.tab="
        handleTabNavigation(
          $event,
          null,
          null,
          '#sessionalreadyopen-dialog',
          null
        )
      "
    >
      <md-dialog-title>{{
        $t("session-already-open-dialog.title")
      }}</md-dialog-title>
      {{ $t("session-already-open-dialog.content-text") }}
      <br />
      <md-button
        class="md-primary"
        @click="
          showDialog = false;
          $emit('logout');
        "
      >
        <md-tooltip
          v-bind:style="isMobile ? 'display: none;' : ''"
          class="tooltip"
          >{{ $t("session-already-open-dialog.close-button") }}
        </md-tooltip>
        {{ $t("session-already-open-dialog.close-button") }}</md-button
      >
    </md-dialog>
  </div>
</template>

<script>
import { isMobile } from "mobile-device-detect";
import Utils from "../utils/Utils.js";

export default {
  mounted() {
    this.isMobile = isMobile;
    this.utils = new Utils();
  },
  data: function() {
    return {
      isMobile: false,
      utils: null
    };
  },
  props: ["confirmjustopen"],
  methods: {
    handleTabNavigation(e, tabsId, choicesId, footerId, closeId) {
      return this.utils.handleTabNavigation(
        e,
        tabsId,
        choicesId,
        footerId,
        closeId
      );
    }
  },
  computed: {},

  components: {}
};
</script>
<style scoped></style>
